import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import {
  Button,
  FormControl,
  FormControlLabel,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../api/hooks/useColors";

const FilterMenuRadio = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
}) => {
  const colors = useColors();
  const [value, setValue] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const initialCheckedState = options.reduce((acc, option) => {
      acc[option.name] = false;
      return acc;
    }, {});

    setValue(initialCheckedState);
  }, []);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    const prevValue = Object.keys(value).find((key) => value[key] === true);
    const initialCheckedState = options.reduce((acc, option) => {
      acc[option.name] = false;
      return acc;
    }, {});
    if (prevValue === event.target.value) {
      const newValue = { ...initialCheckedState };
      setValue(newValue);
      setAppliedFilters({
        ...appliedFilters,
        [fieldName]: newValue,
      });
    } else {
      const newValue = { ...initialCheckedState, [event.target.value]: true };

      setValue(newValue);
      setAppliedFilters({
        ...appliedFilters,
        [fieldName]: newValue,
      });
    }
    //handleClose(); // Close the menu after selection
  };

  return (
    <div>
      <Button
        sx={{
          color: colors.contrast_text_dark,
          height: "32px",
          border: "1px solid " + colors.divider2,
          textTransform: "unset",
          borderRadius: "8px",
          fontSize: "12px",
          display: "flex",
          justifyContent: "space-evenly",
        }}
        aria-controls="filter-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Typography variant="caption">{filterName}</Typography>
        <KeyboardArrowDownRoundedIcon
          style={{ width: "20px", height: "20px" }}
        />
      </Button>
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        sx={{
          color: colors.contrast_text_dark,
          "& .MuiPaper-root": {
            borderRadius: "8px", // or any other value
          },
        }}
      >
        <FormControl component="fieldset">
          <RadioGroup
            aria-label={filterName.toLowerCase().replace(/\s+/g, "-")}
            name={fieldName}
            value={value}
            onClick={handleChange}
          >
            {options.map(({ name, label }) => (
              <MenuItem
                key={name}
                value={name}
                sx={{
                  padding: "0px",
                }}
              >
                <FormControlLabel
                  value={name}
                  checked={value[name]}
                  control={
                    <Radio
                      sx={{
                        width: "16px",
                        height: "16px",
                        "& .MuiSvgIcon-root": { fontSize: "1rem" },
                        "&.Mui-checked": {
                          color: colors.primary_main,
                        },
                      }}
                    />
                  }
                  label={label}
                  sx={{
                    margin: "0px",
                    padding: "8px 16px",
                    width: "100%",
                    "& .MuiFormControlLabel-label": {
                      marginLeft: "10px",
                      fontSize: "12px",
                    },
                  }}
                />
              </MenuItem>
            ))}
          </RadioGroup>
        </FormControl>
      </Menu>
    </div>
  );
};

export default FilterMenuRadio;
